import styled from '@emotion/styled';
import {Grid, List} from '@mui/material';

export const ComponentLoaderGrid = styled(Grid)`
  height: 100%;
  width: 100%;
  display: flex;
  // margin-top: 5rem;
  align-items: center;
  justify-content: center;
`;

export const UserGroupsGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid rgba(145, 158, 171, 0.2);
  flex-wrap: nowrap;
`;

export const LeftGrid = styled(Grid)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  height: 100%;
`;

export const RightGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-left: 1px solid rgba(145, 158, 171, 0.2);
  height: 100%;
`;

export const TopGrid = styled(Grid)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 0;
  height: 3.5rem;
  border-bottom: 1px solid rgba(145, 158, 171, 0.2);
  flex-wrap: nowrap;
`;

export const TopActionGrid = styled(Grid)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 0;
  height: 5.9vh;
  width: 100%;
  border-bottom: 1px solid rgba(145, 158, 171, 0.2);
`;

export const ActionButtonGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
`;

export const ButtonsGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  margin-right: 1rem;

  @media screen and (max-width: 400px) {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: nowrap;
    margin-right: 0.2rem;
  }
`;
export const RoleNameTypographyGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 2.5rem;
  height: 2.5rem;
  border-radius: 10px;
  font-size: 1.2rem;
`;

export const RoleAndPermissionsWrapperGrid = styled(Grid)`
  display: flex;
  align-items: flex-start;

  flex-direction: row;
  width: 100%;
  height: 78vh;
  row-gap: 2px;
  background-color: #f9f9f9;
  overflow: auto;
  @media screen and (max-height: 800px) {
    height: 68vh;
  }

  @media screen and (max-height: 600px) {
    height: 60vh;
  }
`;

export const RoleAndPermissionsLoaderContainerGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin: 6rem auto auto auto;
`;

export const RoleAndPermissionsContainerGrid = styled(Grid)`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding: 1rem;
  // margin-left: 1.5rem;
  // margin-right: 1.5rem;
`;

export const NoRoleAndPermissionsContainerGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding-top: 5rem;
  padding-right: 1rem;
  padding-left: 1rem;
`;

export const RoleGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // margin: 1.5rem 4rem 0 0rem;
  padding: 0.5rem;
  border: 1px solid #d8d8d8;
  background-color: white;
  border-radius: 8px;
  flex-wrap: nowrap;

  @media screen and (max-width: 600px) {
    margin-right: 0;
  }
`;

export const AdGroupGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  border: 1px solid #d8d8d8;
  background-color: white;
  border-radius: 8px;
  flex-wrap: nowrap;

  @media screen and (max-width: 600px) {
    margin-right: 0;
  }
`;

export const RoleItemGrid = styled(Grid)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
`;

export const PermissionsListGrid = styled(Grid)`
  display: flex;
  height: 70vh;
  border: 1px solid #d8d8d8;
  background-color: white;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  // margin-top: 1.5rem;
`;

export const PermissionsHeading = styled('h3')`
  font-weight: normal;
  font-size: 1.3rem;
  padding: 0.4rem 0 0.6rem 0;
`;

export const PermissionsList = styled(List)`
  overflow-y: auto;
  width: 100%;
  height: 91%;
`;

export const DetailsGrid = styled(Grid)`
  color: #118AB2;
  font-size: 1rem;

  &:hover {
    color: #06D6A0;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const NoPermissionGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const SearchContainerGrid = styled(Grid)`
  padding: 0.4rem;
  width: 100%;
`;

export const UserGroupListContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
`;

export const UserGroupListLoaderGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
